import React, { useEffect, useRef } from "react";
import { Fragment } from "react";
import { Form, Input, Button, message } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  useSendPasswordResetEmail,
  useSignInWithEmailAndPassword,
} from "react-firebase-hooks/auth";
import auth from "../../../FirebaseInit/FirebaseInit";
import useToken from "../../../Hooks/useToken";
import ScrollToTop from "../../Shear/ScrollToTop";
import Head from "../../../layout/Head";
import Header from "../../Shear/Header/Header";
import Footer from "../../Shear/Footer/Footer";

const Login = () => {
  let navigate = useNavigate();
  let location = useLocation();
  let from = location.state?.from?.pathname || "/";
  const emailRef = useRef("");

  const [signInWithEmailAndPassword, user, loading, error] =
    useSignInWithEmailAndPassword(auth);
  const [sendPasswordResetEmail, rError] = useSendPasswordResetEmail(auth);
  const [token] = useToken(user);

  useEffect(() => {
    if (token) {
      navigate(from, { replace: true });
    }
  }, [token, user, navigate, from]);

  let errorMessage = "";
  if (error || rError) {
    errorMessage = error?.message || rError?.message;
    message.error(errorMessage);
  }

  const onSubmitHandler = (values) => {
    signInWithEmailAndPassword(values.email, values.password);
  };

  const handleForgotPassword = async () => {
    if (emailRef.current.value) {
      await sendPasswordResetEmail(emailRef.current.value);
      message.success("Password reset email sent. Please check your inbox.");
    } else {
      message.error("Enter your email");
    }
  };

  return (
    <Fragment>
      <Head
        Title="Login "
        href="/login"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Login Pages"
      />
      <Header />
      <section className="bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center justify-center py-28 px-6">
          <div className="w-full bg-white rounded-lg shadow-md dark:border max-md:mt-0 max-sm:max-w-md max-xl:p-0 border-2 border-[#fbfbfb]">
            <div className="p-6 space-y-4 max-md:space-y-6 max-sm:p-8">
              <h2 className="text-xl font-bold leading-tight tracking-tight text-gray-900 max-md:text-2xl text-linear-gradient  ">
                Login
              </h2>
              <Form
                onFinish={onSubmitHandler}
                className="space-y-4 max-md:space-y-6"
              >
                <Form.Item
                  label="Your email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined />}
                    placeholder="Enter Your Email"
                    ref={emailRef}
                  />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="••••••••"
                  />
                </Form.Item>
                <div className="text-right">
                  <p
                    onClick={handleForgotPassword}
                    className="text-[red] text-base underline cursor-pointer"
                  >
                    Forgot your password?
                  </p>
                </div>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    className="w-full h-[50px]      custom_button hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                  >
                    Login
                  </Button>
                </Form.Item>
                <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                  Already have an account?{" "}
                  <Link
                    to="/register"
                    className="font-medium text-primary underline "
                  >
                    Sign Up here
                  </Link>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </section>
      <ScrollToTop />
      <Footer />
    </Fragment>
  );
};

export default Login;
